import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { GoalsService } from '../goals.service';
import { GoalsReviewValidationPage } from './goals-review-validation.page';
import { ReviewInputValidationPage } from './review-input-validation/review-input-validation.page';
import { UtilService } from 'src/app/shared/services/util.service';
import { StepDescriptionModule } from 'src/app/shared/components/step-description/step-description.module';
import { QuestionTypesModule } from 'src/app/shared/components/question-types/question-types.module';
import { NewGoalsInputModule } from 'src/app/shared/modals/new-goals-input/new-goals-input.module';

const routes: Routes = [{
    path: '',
    component: GoalsReviewValidationPage
}, {
    path: ':userId',
    component: ReviewInputValidationPage
}];

@NgModule({    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        FormsModule,
        ReactiveFormsModule,
        QuestionTypesModule,
        StepDescriptionModule,
        NewGoalsInputModule
    ],
    declarations: [
        GoalsReviewValidationPage,
        ReviewInputValidationPage
    ],    providers: [
        GoalsService,
        UtilService
    ]
})
export class GoalsReviewValidationModule {
}
